<!-- 会员管理 -->
<template>
    <el-card class="fitness-index">
        <template>
            <el-button type="primary" @click.prevent="MembershipRenewal">
                {{ $t('Member.xu') }}
            </el-button>
            <el-button type="primary" @click="addCard('storeValue', 3)">
                {{ $t('Member.add_card') }}
            </el-button>
            <el-button type="primary" @click="addCard('personal', 4)">
                {{ $t('Member.add_personal') }}
            </el-button>
            <el-button type="primary" @click="addCard('locker', 4)">
                {{ $t('Member.add_locker') }}
            </el-button>
            <el-button type="primary" @click="depositCharge">
                {{ $t('Charge.title1') }}
            </el-button>
            <el-button type="primary" @click="depositCollection">
                {{ $t('Sell.Charge.ya') }}
            </el-button>
            <el-button type="primary" @click="TransferShop">
                {{ $t('Member.transfer_store') }}
            </el-button>
            <el-button type="primary" @click="sendMsg">
                {{ $t('Member.Send') }}
            </el-button>
        </template>
        <el-table
            border
            ref="tableData"
            v-if="tableData"
            :data="tableData"
            class="my-4"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange"
        >
            <el-table-column type="selection" width="30px"></el-table-column>
            <el-table-column
                prop="id"
                :label="$t('Card.client_id')"
                align="center"
                width="100px"
                v-if="false" />
            <el-table-column
                prop="storeNames"
                :label="$t('Common.store')"
                align="center"/>
            <el-table-column
                prop="mshpSalesNickname"
                :label="$t('Common.saler')"
                align="center"/>
            <el-table-column
                prop="salesFollowStatus"
                :label="$t('Member.Follow.saler_status')"
                align="center"/>
            <el-table-column
                prop="salesFollowAt"
                :label="$t('Member.Follow.last_time')"
                align="center"/>
            <el-table-column
                prop="coachNickname"
                :label="$t('Common.coach')"
                align="center"/>
            <el-table-column
                prop="coachFollowStatus"
                :label="$t('Member.Follow.coach_status')"
                align="center"
                width="120"/>
            <el-table-column
                prop="coachFollowAt"
                :label="$t('Member.Follow.coach_last_time')"
                align="center"/>
            <el-table-column
                prop="name"
                :label="$t('Card.client_name')"
                align="center"/>
            <el-table-column
                prop="gender"
                :label="$t('Common.gender')"
                align="center" />
            <el-table-column
                prop="phone"
                :label="$t('Common.phone_number')"
                align="center"
                width="110"/>
            <el-table-column
                prop="mshpAt"
                :label="$t('Member.enter_date')"
                align="center"
                width="100"/>
            <el-table-column
                prop="cardNames"
                :label="$t('Card.service')"
                align="center"/>
            <el-table-column
                prop="totalConsumption"
                :label="$t('Sell.Pay.all')"
                align="center"/>
            <el-table-column
                prop="mshpExpiredAt"
                :label="$t('Member.Time.end')"
                align="center"
                width="100px"/>
            <el-table-column
                prop="clientTagNames"
                :label="$t('Client.Add.customer_label')"
                align="center"/>
            <el-table-column
                prop="activeName"
                :label="$t('Client.Add.status')"
                align="center"/>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-center"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>

        <!-- 续会 -->
        <mshp-contract-form ref="mshpContract" :type="2" :isDeposit="false"/>

        <!-- visible 显示 -->
        <a-new-contract
            v-if="visible"
            @close="visible = false"
            ref="newContract"
            :activeName="activeName"
            :contract="contract"
            :isDeposit="false"
            :infoType="infoType"
            :data="client"
            @fetchData="fetchData" />

        <!-- 发送短信 -->
        <send-message-form ref="sendMessage"/>
        <!-- 收取定金 -->
        <deposit-charge ref="charge" />
        <!-- 收取押金 -->
        <deposit-collection ref="collection" />
        <!-- 转让店铺 -->
        <transfer-shop ref="shop" @fetchData="fetchData" />
    </el-card>
</template>

<script>
import { Dialog } from 'element-ui';
import MshpContractForm from '@/components/Dialog/Client/MshpContractForm';
import SendMessageForm from '@/components/Dialog/Client/SendMessageForm';
import NewContract from '@/components/Dialog/Client/NewContract';
import DepositCharge from '@/components/Dialog/Client/DepositCharge';
import DepositCollection from '@/components/Dialog/Client/DepositCollection';
import TransferShop from '@/components/Dialog/Client/TransferShop';

export default {
    props: ['activeName', 'ids', 'clientId'],
    components: {
        ElDialog: Dialog,
        MshpContractForm,
        SendMessageForm,
        ANewContract: NewContract,
        DepositCharge,
        DepositCollection,
        TransferShop,
    },
    data() {
        return {
            contract: {name: ''},
            loading: false,
            tableData: [],
            clientIds: [],
            clients: [],
            form: {
                mshpSalesId: '',
                createdAtStart: '',
                createdAtEnd: '',
                active: '',
                editorId: '',
                categoryCode: '',
                clientTagIds: [],
                followLevelCode: '',
                channelSourceCode: '',
                channelAttrCode: '',
                age: '',
                genderCode: '',
                birthdayStart: '',
                birthdayEnd: '',
                hasAvatar: '',
                marriageCode: '',
                childrenCode: '',
                infoHabitCode: '',
                personalHobbyCode: '',
                joinedClubCode: '',
                joinedClubBrand: '',
                fitnessPurposeCode: '',
                wasFitnessMemberCode: '',
                leftReasonCode: '',
                keyword: '',
            },
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            visible: false,
            infoType: null,
            client: null,
        };
    },
    watch: {
        activeName(val) {
            if (val === 'second') this.fetchData();
        },
        'clientId'(val) {
            if (this.activeName === 'second') this.fetchData();
        },
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            const tagIds = this.form.clientTagIds;
            const contractStoreIds = this.form.contractStoreIds;
            this.$delete(this.form, 'clientTagIds');
            API.get('client/full/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                    clientTagIds: tagIds ? tagIds.join(',') : null,
                    clientIds: this.clientId ? this.clientId : '',
                    contractStoreIds: contractStoreIds ? contractStoreIds.join(',') : null,
                },
            })
            .then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
            })
            .finally(() => {
                this.loading = false;
            });
        },
        say(data) {
            this.form = data;
            this.fetchData();
        },
        handleReset() {
            this.form = {};
            this.fetchData(1);
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        handleSelectChange(val) {
            this.clientIds = val.map(el => el.id);
            this.clients = val;
            this.$emit('listenClientIds', this.clients);
        },
        MembershipRenewal() {
            if (this.validSelect()) {
                if (this.$$filterPermission('客户-客户/会员管理-入会/续会籍/买私教/买租赁柜/收定金/转店'))
                    this.$refs.mshpContract.open(this.clients[0].id);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        validSelect() {
            if (this.clients.length > 1) $ele.$message.warning(this.$t('Message.info_one'));
            else if (this.clients.length < 1) $ele.$message.warning(this.$t('Message.plase_one_info'));
            else return true;
        },
        sendMsg() {
            if (this.clientIds.length && this.$$filterPermission('客户-客户/会员管理-发短信'))
            this.$refs.sendMessage.open(this.clientIds);
            else if (!this.clientIds.length) $ele.$message.warning(this.$t('Message.choose_once'));
        },
        // type:合同类型
        // infoType: 获取会员初始化合同必要信息type类型
        addCard(type, infoType) {
            if (this.validSelect()) {
                this.$set(this.contract, 'name', type);
                if (this.$$filterPermission('客户-客户/会员管理-入会/续会籍/买私教/买租赁柜/收定金/转店')) {
                    this.infoType = infoType;
                    this.client = this.clients[0].id;
                    this.visible = true;
                }
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 收取定金
        depositCharge() {
            if (this.validSelect()) {
                if (this.$$filterPermission('客户-客户/会员管理-入会/续会籍/买私教/买租赁柜/收定金/转店')) {
                    this.$refs.charge.open(this.clients[0]);
                }
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        // 押金收取
        depositCollection() {
            if (this.validSelect()) this.$refs.collection.open(this.clients[0]);
        },
        // 转店
        TransferShop() {
            if (this.validSelect()) {
                if (this.$$filterPermission('客户-客户/会员管理-入会/续会籍/买私教/买租赁柜/收定金/转店')) {
                    this.$refs.shop.open(this.clients[0]);
                }
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
    },
    created() {
        if (this.activeName === 'second') this.fetchData();
    },
};
</script>
<style lang="scss">
.icon {
    position: absolute !important;
    right: 0px;
    display: inline;
}
</style>
